import { Block } from 'components/Block'
import { IconName } from 'components/icon'
import { PricingPlanPerk } from 'components/trustWillPerksSection/TrustWillPerksSection'
import { Caption } from 'components/Typography'
import { Trans, useTranslation } from 'next-i18next'
import { colors } from 'utils/colors'
import { numberRange } from 'utils/general'
import { SFeaturesStack, SPlanFeaturesWrapper } from './PricingPlanFeatures.styled'

export const PricingPlanFeatures = () => {
  const { t } = useTranslation('pricing_plan', {
    keyPrefix: 'pricing_plan.pricing_page.plan_features',
  })

  const perkIcons: IconName[] = [
    'People',
    'DocumentReady',
    'DigitalVault',
    'CalendarRefresh',
    'Phone',
    'TimeClock',
  ]

  const perks = numberRange(6).map((i) => ({
    icon: perkIcons[i - 1],
    title: <Trans t={t} i18nKey={`perks.perk_${i}`} components={{ b: <strong /> }} />,
    tooltipText: t(`perk_tooltips.perk_${i}`),
  }))

  return (
    <Block>
      <SPlanFeaturesWrapper space="3rem">
        <Caption css={{ marginBottom: '3rem' }}>{t('title')}</Caption>
        <SFeaturesStack space="0.5rem">
          {perks.map((perk, index) => (
            <PricingPlanPerk
              title={perk.title}
              tooltipText={perk.tooltipText}
              index={index}
              color={colors.blue[500]}
              icon={perk.icon}
              key={perk.title.toString()}
              orientation="right"
            />
          ))}
        </SFeaturesStack>
      </SPlanFeaturesWrapper>
    </Block>
  )
}
